import z from 'zod';

const configSchema = z.object({
  logoutUrl: z.string(),
  loginUrl: z.string(),
  authStatusUrl: z.string(),
  subscriptionKey: z.string(),
  apiUrl: z.string(),
  applicationInsightsConnectionString: z.string(),
});

export type Config = z.infer<typeof configSchema>;

export default configSchema;
